export default {
      id: "bin-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.c6bd5ddf.svg#bin",
      toString: function () {
        return this.url;
      }
    }